import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Blogs from "./pages/Blogs";
import BlogReader from "./pages/BlogReader";
import ContactUs from "./pages/ContactUs";
import Properties from "./pages/Properties";
import PropertyDetails from "./pages/PropertyDetails";
import MLS from "./pages/MLS";
import Testimonials from "./pages/Testimonials";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogReader />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/property/:slug" element={<PropertyDetails />} />
          <Route path="/mls" element={<MLS />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
